<script>
    import Layout from "../../layouts/main";
    import appConfig from "@/app.config";
    import apigeneric from "@/helpers/apigeneric";
    import Loader from "@/components/widgets/loader";
    import Banner from "../components/banner";
    import apibtoast from "@/helpers/apibtoast";
    
    export default {
      page: {
        title: "Web Siteleri",
        meta: [
          {
            name: "description",
            content: appConfig.description,
          },
        ],
      },
      components: {
        Layout,
        Loader,
        Banner
    
      },
      mixins: [apigeneric, apibtoast],
      data() {
        return {
          TableData: {},
          DefaultPage: 1,
          Page: {
            PageNumber: "1",
            PageSize: "10",
            PageDataSize: "1",
          },
          LangId: this.$route.params.LangId,
          VeritabaniTitle: {}
          
          
          
        };
      },
      methods: {
        Get() {

          if(this.LangId=="tr" || this.LangId== null){
            this.ActionsFilterGet({ Service: "aboneveritabanlari", 
        Page: this.Page,
       Filter: "&Websiteid="+window.$cookies.get("website")
        }).then(
        (res) => {
          this.TableData = res.Data;
          this.Page.PageDataSize = res.TotalCount;
        });
    }else{
      this.ActionsFilterGet({
        Service: "languages",
        Page: this.Page,
        Filter:
       "&shortlangtitle="+this.LangId
      }).then((res) => {
        for( let LangData in res.Data){
          this.ActionsFilterGet({
        Service: "aboneveritabanlaritranslations",
        Page: this.Page,
        Filter: "&Langid="+ res.Data[LangData].Id + "&Websiteid="+window.$cookies.get("website")
      }).then((res) => {
        this.TableData = res.Data;
        if(res.TotalCount == 0){
              localStorage.setItem("lang", "tr");
              window.location.reload();
              
            }
        
      });
         }
        
      });
     
    }
    
    this.ActionsFilterGet({
        Service: "languages",
        Page: this.Page,
        Filter:
          "&shortlangtitle=" + this.LangId
      }).then((res) => {
        for (let LangData in res.Data) {
          this.ActionsFilterGet({
            Service: "LanguagereSources",
            Page: this.Page,
            Filter: "&Langid=" + res.Data[LangData].Id + "&Resourceid=cda790bd-200d-4a2f-9edf-1139c56eec63"
          }).then((res) => {
            this.VeritabaniTitle = res.Data;
            if (res.TotalCount == 0) {
              localStorage.setItem("lang", "tr");
              window.location.reload();
            }
          });
        }
      });
      
          }
      },
    };
    </script>
        
    <template>
      <Loader>
        <Layout>
          <Banner />
          <div class="graduates">
        <div class="container">
          <div class="table-graduate">
            <p class="h2 text-center cl-service-dark">{{ VeritabaniTitle[0].Resourcevalue }}</p>
            <div class="container">
              

              <ul class="table-main">
                <li class="head bg-service">
                  <div class="row">
                    <div class="col-md-9">
                      <span class="order">{{
                        $t("aboneveritabanlari.Table.Baslik")
                      }}</span>
                    </div>
                    <div class="col-md-3" style="text-align:center">
                      <span>{{ $t("aboneveritabanlari.Table.Islem") }}</span>
                    </div>
                  </div>
                </li>
                <li v-for="(Data, index) in TableData" :key="index">
                  <div class="col-md-12">
                    <div class="row">
                      <div class="col-md-9 l-flex">
                        <span class="order">{{ Data.Veritabaniadi }}</span>
                      </div>
                
                      
                     
                      <div class="col-md-3" style="text-align:center"  >
                        <b-button-group>
                        <router-link 
                          class="btn btn-info bx bx-search-alt mx-auto"
                          style="color: #00758f; font-size: 20px;"
                          id="topnav-components"
                          :to="'/aboneveritabanidetails/' + LangId + '/' + Data.Veritabaniadi.toLowerCase()
                                    .replace(/I|İ/gi, 'i')
                                    .replace(/Ğ|ğ/gi, 'g')
                                    .replace(/Ç|ç|ğ/gi, 'c')
                                    .replace(/\s+/g, '-')
                                    .replace(/&/g, `-and-`)
                                    .replace(/--/g, `-`) + '/'
                 + Data.Id"
                          role="button"
                        >
                          <i></i>
                        </router-link>
                     </b-button-group>
                      </div>
                    </div>
                  </div>
                </li>
              </ul> 
              <b-pagination
                class="pagination pagination-rounded justify-content-end mb-2"
                v-model="DefaultPage"
                :total-rows="Page.PageDataSize"
                :per-page="Page.PageSize"
                aria-controls="my-table"
                @input="ChangePage(DefaultPage)"
              >
              </b-pagination>
            </div>
          </div>
        </div>
      </div>
    
          
        </Layout>
      </Loader>
    </template>
        